import { render, staticRenderFns } from "./Overlap.vue?vue&type=template&id=2a8c2a0e&scoped=true"
import script from "./Overlap.vue?vue&type=script&lang=js"
export * from "./Overlap.vue?vue&type=script&lang=js"
import style0 from "./Overlap.vue?vue&type=style&index=0&id=2a8c2a0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c2a0e",
  null
  
)

export default component.exports